import { Button } from '@jouzen/ecom-components/v3/Button';
import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';

import CareersTextAnimation from './CareersTextAnimation';

const CareersIntro = () => {
  const t = useTranslations();

  return (
    <section data-cy="careers-intro">
      <LayoutGrid>
        <GridItem
          className="pb-2 text-blue-200"
          colEnd={{ sm: 'main', lg: 6 }}
          colStart={{ sm: 'main' }}
          rowStart={{ lg: 1 }}
        >
          <Typography Element="h1" variant="base" color="inherit">
            {t('careers_at_oura')}
          </Typography>
        </GridItem>
        <GridItem
          className="mb-8"
          colEnd={{ sm: 'main', lg: 15 }}
          colStart={{ sm: 'main', lg: 11 }}
          rowStart={{ sm: 2, lg: 1 }}
        >
          <CareersTextAnimation endText="Hello" startText="Hei" />
        </GridItem>
      </LayoutGrid>
      <LayoutGrid className="md:mt-12 lg:mt-16" rowGap={64}>
        <GridItem
          className="lg:flex lg:items-center"
          colEnd={{ sm: 'main' }}
          colStart={{ sm: 4, md: 6, lg: 15 }}
          rowStart={{ lg: 1 }}
        >
          <div>
            <Typography>{t('how_oura_was_founded')}</Typography>
            <div className="mt-8">
              <Button href="#open-positions" variant="secondary-dark">
                {t('see_open_positions')}
              </Button>
            </div>
          </div>
        </GridItem>
        <GridItem
          className="relative aspect-3/5 py-72 md:aspect-auto"
          colEnd={{ sm: 'main', lg: 13 }}
          colStart={{ sm: 'full', lg: 'main' }}
          rowStart={{ lg: 1 }}
        >
          <ArtDirectionImage
            className="object-cover"
            fill
            sizes="(max-width: 767px) 390px, 566px"
            localizedAlt="career_intro_hero_v2_alt"
            srcSet={[
              {
                media: '(min-width: 1024px)',
                src: 'blue-sky/careers/careers-hero-1024.jpg?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.45&fp-z=1',
              },
              {
                media: '(min-width: 768px)',
                src: 'blue-sky/careers/careers-hero-1024.jpg?ar=3:2&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.4&fp-z=1',
              },
              {
                src: 'blue-sky/careers/careers-hero-1024.jpg?ar=3:5&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.5&fp-z=1',
              },
            ]}
          />
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default CareersIntro;
